/** `yyyy-MM-dd` -> `dd/MM/yyyy`; vazio vira traço. */
export function formatDataBr(value: string): string {
  if (!value) return "—";
  const [year = "", month = "", day = ""] = value.slice(0, 10).split("-");
  return `${day}/${month}/${year}`;
}
